import { makeStyles } from "@material-ui/core/styles";
import { weatherTimeWithID, WX_ID_VAA } from "../../../store/WeatherContentsState";
import { useRecoilValue } from "recoil";
import volcanoImg from "../../../images/contents/map/vaa/volcano.png";

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'column-reverse',
    flexWrap:'wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  item: {
    position: 'relative',
    lineHeight: '18px',
    height: '18px',
    paddingLeft: '10px'
  },
  volcano: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  iconWrap: {
    display: "inline-block"
  },
  icon: {
    verticalAlign: "middle"
  },
  iconActual: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #ff0000',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  iconFT6: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #ffc0cb',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  iconFT12: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #ffa500',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  iconFT18: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #1e90ff',
    margin: '0 auto',
    verticalAlign: "middle"
  },

  label: {
    display: "inline-block",
    textAlign: 'left',
    paddingLeft: '5px',
    width:100
  }
}));


function LegendVaa() {
  const classes = useStyles();
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_VAA));
  return (
    <div>
      <div className="legend-contents-time">
        {timeInfo.baseTime}
      </div>
      <ul className={classes.box}>
        <li className={classes.volcano}>
          <span className={classes.iconWrap}><img src={volcanoImg} alt="Volcano" className={classes.icon}/></span><span className={classes.label}>Volcano</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={classes.iconActual}></span></span><span className={classes.label}>ACTL</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={classes.iconFT6}></span></span><span className={classes.label}>FT 6H</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={classes.iconFT12}></span></span><span className={classes.label}>FT 12H</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={classes.iconFT18}></span></span><span className={classes.label}>FT 18H</span>
        </li>
      </ul>
    </div>
  )
}

export default LegendVaa;